import { Response } from "@/shared/models/Response";
import axios from "axios";
import {
  AvailabilityTemplate,
  AvailabilityTemplateResponse
} from "../models/AvailabilityTemplateModel";
import { AvailabilityTemplateIdNameResponse } from "../models/AvailibilityIdNameModel";
import { AvailabilityTemplateFilter } from "../models/AvailabilityTemplateFilterModel";

export class AvailabilityTemplateService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_SCHEDULING_API}/availability-template`;
  }

  async getAvailabityTemplateById(
    templateId: string
  ): Promise<Response<AvailabilityTemplateResponse>> {
    const serviceURL = `${this.baseUrl}/${templateId}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getAvailabitiesTemplate(
    idReference: string,
    name: string
  ): Promise<Response<AvailabilityTemplateIdNameResponse>> {
    const serviceURL = `${this.baseUrl}/get-availabilities-templates`;
    const response = await axios.get(serviceURL, {
      params: {
        idReference: idReference ?? "",
        name: name ?? ""
      }
    });
    return response.data;
  }
  async filterAvailabitiesTemplate(
    filter: AvailabilityTemplateFilter
  ): Promise<Response<AvailabilityTemplateIdNameResponse>> {
    const serviceURL = `${this.baseUrl}/filter`;
    const response = await axios.get(serviceURL, {
      params: filter
    });
    return response.data;
  }

  async saveAvailabilityTemplate(
    availabilityTemplate: AvailabilityTemplate
  ): Promise<Response<string | void>> {
    const response = await axios.post(this.baseUrl, availabilityTemplate);
    return response.data;
  }

  async deleteAvailabilityTemplate(
    templateId: string
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/${templateId}`;
    const response = await axios.delete(serviceURL);
    return response.data;
  }
}
